import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=0ad971fd&scoped=true"
import script from "./RolePage.vue?vue&type=script&lang=js"
export * from "./RolePage.vue?vue&type=script&lang=js"
import style0 from "./RolePage.vue?vue&type=style&index=0&id=0ad971fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad971fd",
  null
  
)

export default component.exports